<div class="c-dialog-template-title"
  [ngClass]="[
    color ? 'c-dialog-template-title--color-' + (color | toCssClassName) : '',
    color ? 'c-dialog-template-title--align-text-' + (textAlign | toCssClassName) : '',
    pagerVisible ? 'c-dialog-template-title__pager-visible--' + pagerVisible : '',
  ]">
  <ng-content></ng-content>
</div>
